import { ClientOnly } from "@tanstack/react-router";

export function UmamiAnalytics() {
  return (
    <ClientOnly>
      <UmamiAnalyticsScript />
    </ClientOnly>
  );
}

function UmamiAnalyticsScript() {
  if (!window.__INJECTED_ENV__.UMAMI_URL || !window.__INJECTED_ENV__.UMAMI_WEBSITE_ID) {
    return null;
  }

  return (
    <script
      async
      defer
      src={`${window.__INJECTED_ENV__.UMAMI_URL}/script.js`}
      data-website-id={window.__INJECTED_ENV__.UMAMI_WEBSITE_ID}
    />
  );
}
